import React, { PureComponent } from 'react';
import classNames from 'classnames';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Header } from 'formlabs-web-components/Type';
import { Button } from 'formlabs-web-components/Link';
import { CarouselWrapper } from 'formlabs-web-components/Media';
import { Grid, Cell } from 'formlabs-web-components/Grid';

import './Employee.module.css';

const FeaturedEmployeesSection = DisplayComponent(
  class FeaturedEmployeesSection extends PureComponent {
    constructor(props) {
      super(props);
      this.state = { mobile: false };
    }
    componentDidMount() {
      window.addEventListener('resize', this.resize.bind(this));
      this.resize();
    }

    resize() {
      this.setState({ mobile: window.innerWidth <= 640 });
    }
    render() {
      const { title, children, copy, ctaText, classes } = this.props;

      return (
        <div
          className={classNames('has-full-container', classes)}
          style={{ marginTop: '6rem' }}
        >
          <Grid direction="x" primaryAlignment="align-center">
            <Cell
              largeSize="8"
              styles={{
                background: `#515157`,
                backgroundSize: 'cover',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex'
              }}
            >
              <div styleName="employee-header">
                <Header
                  level={5}
                  displayAs={4}
                  weight={700}
                  styles={{ color: '#fff' }}
                >
                  {title}
                </Header>
                <div
                  dangerouslySetInnerHTML={{ __html: copy }}
                  style={{ color: '#fff', margin: '40px 0' }}
                />
                {ctaText && (
                  <Button
                    url="https://medium.com/formlabs-people"
                    target="_blank"
                    color="white"
                  >
                    {ctaText}
                  </Button>
                )}
              </div>
            </Cell>
            <Cell largeSize="16">
              {!this.state.mobile && (
                <Grid
                  direction="x"
                  primaryAlignment="align-center"
                  addStyleNames="small-up-1 medium-up-3"
                  styles={{ paddingLeft: '2px' }}
                >
                  {children.map(child => (
                    <Cell
                      key={child.key}
                      styles={{
                        backgroundColor: '#f6f6f6',
                        borderLeft: '2px solid #fff',
                        marginLeft: '-2px'
                      }}
                    >
                      {child}
                    </Cell>
                  ))}
                </Grid>
              )}
              {this.state.mobile && (
                <CarouselWrapper controlsPosition={'internal'}>
                  {children.map(child => (
                    <div>{child}</div>
                  ))}
                </CarouselWrapper>
              )}
            </Cell>
          </Grid>
        </div>
      );
    }
  }
);
FeaturedEmployeesSection.propTypes = {};

export default FeaturedEmployeesSection;
